import type { SectorPlanFeatures } from "@/types";
import type { SectorAccessState } from "./useSectorAccessState";

export type PlanFeatureKey = keyof SectorPlanFeatures;

/**
 * O plano do setor libera o recurso? Regra pura do gate de plano, lida do
 * access-state. PARIDADE: o backend aplica a mesma regra em
 * `backstrapi/src/utils/billing/planFeatureAccess.ts` (`hasPlanFeature`), com
 * teste de paridade em `backstrapi/tests/unit/planFeatureAccess.unit.test.ts`.
 * Mudou aqui, muda lá (e o teste de lá copia a tabela deste arquivo). (a subscription/plan populada no /sectors/:id é removida pela
 * sanitização de RBAC, então confiar no populate retornaria sempre "sem
 * features" para não-internos). Ver [[rbac-strips-populated-subscription]].
 */
export function hasPlanFeature(
  access: SectorAccessState,
  feature: PlanFeatureKey
): boolean {
  // BIL-63: contas internas liberam qualquer feature.
  if (access.is_internal) return true;

  if (!access.subscription_status) return false;
  if (access.subscription_status === "canceled") return false;
  if (access.subscription_status === "trialing") return true;

  return Boolean(access.plan_features?.[feature]);
}
